import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "kgb.hiddenColumns";

const readHidden = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY)) || []);
  } catch {
    return new Set();
  }
};

/**
 * Which grid columns are hidden. Remembered per browser — a viewing
 * preference, not data, so it never goes to the server.
 *
 * @param {{ key: string, locked?: boolean }[]} columns
 */
export function useColumnVisibility(columns) {
  const [hidden, setHidden] = useState(readHidden);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...hidden]));
    } catch {}
  }, [hidden]);

  const toggle = useCallback(
    (key) => {
      if (columns.find((column) => column.key === key)?.locked) return;
      setHidden((current) => {
        const next = new Set(current);
        if (next.has(key)) next.delete(key);
        else next.add(key);
        return next;
      });
    },
    [columns],
  );

  const showAll = useCallback(() => setHidden(new Set()), []);

  return { hidden, toggle, showAll };
}
